<template>
  <div class="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl mx-auto">

      <!-- Avatar and Heading -->
      <div class="flex flex-col items-center text-center mb-6 animate-fadeInUp">
        <img
          :src="avatar"
          alt="Your avatar"
          class="w-28 h-28 rounded-full object-cover border-2 border-bright-blue shadow-sm mb-4"
        />
        <h1 class="text-3xl font-bold text-gray-800">Egbert Joel</h1>
        <p class="text-sm text-gray-500">MQL5 + Web Developer</p>
      </div>

      <!-- Bio Section -->
      <div class="bg-white p-6 rounded-xl shadow animate-fadeInUp">
        <p class="text-gray-700 text-lg leading-relaxed mb-4">
          👋 Hey — I'm Egbert Joel. I’m a developer who loves building clean, reliable software that <em>just works</em>.
        </p>
        <p class="text-gray-700 text-lg leading-relaxed mb-4">
          I started out coding in <strong>Python</strong> and <strong>Java</strong>, later diving deep into <strong>web development</strong> using <strong>Vue.js</strong>, <strong>Laravel</strong>, <strong>Flask</strong>, and <strong>Express</strong>. That background shaped how I think about structure, clarity, and user experience — even in trading systems.
        </p>
        <p class="text-gray-700 text-lg leading-relaxed mb-4">
          Today, I focus on building tools for traders using <strong>MQL5</strong> — from full Expert Advisors to custom dashboards, alerts, and conversions from Pine Script or indicator logic. I bring the same engineering mindset to every project: clean code, reliable execution, and systems that support your edge.
        </p>
        <p class="text-gray-700 text-lg leading-relaxed italic">
          “Trading is hard. Your tools shouldn’t be.”
        </p>
      </div>

      <!-- Tech Stack Section -->
      <div class="mt-10 fade-in-on-scroll" v-scroll-fade>
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Tech Stack</h2>
        <div class="flex flex-wrap gap-3">
          <span class="bg-blue-100 text-blue-800 text-xs font-medium px-3 py-1 rounded-full">MQL5</span>
          <span class="bg-green-100 text-green-800 text-xs font-medium px-3 py-1 rounded-full">Python</span>
          <span class="bg-yellow-100 text-yellow-800 text-xs font-medium px-3 py-1 rounded-full">Java</span>
          <span class="bg-teal-100 text-teal-800 text-xs font-medium px-3 py-1 rounded-full">Vue.js</span>
          <span class="bg-red-100 text-red-800 text-xs font-medium px-3 py-1 rounded-full">Laravel</span>
          <span class="bg-gray-200 text-gray-800 text-xs font-medium px-3 py-1 rounded-full">Flask</span>
          <span class="bg-purple-100 text-purple-800 text-xs font-medium px-3 py-1 rounded-full">Express</span>
          <span class="bg-indigo-100 text-indigo-800 text-xs font-medium px-3 py-1 rounded-full">SQL</span>
          <span class="bg-pink-100 text-pink-800 text-xs font-medium px-3 py-1 rounded-full">MongoDB</span>
          <span class="bg-orange-100 text-orange-800 text-xs font-medium px-3 py-1 rounded-full">Tailwind CSS</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import avatar from "@/assets/avatar-compressed.png";

export default {
  name: "AboutPage",
  data() {
    return {
      avatar,
    };
  },
};
</script>
